module.exports = __webpack_public_path__ + "img/Patch7.e35aa023.webp";